import BaseLayout from "../components/layout/BaseLayout";

const Impressum = () => (
  <BaseLayout>
    <div className="flex flex-col items-center px-6 md:px-10">
      <div className="w-full max-w-3xl bg-white rounded-2xl shadow-lg border border-gray-100 p-8 md:p-10 text-gray-900">
        <h1 className="text-4xl font-bold text-center mb-8">Impressum</h1>

        <div className="space-y-4 text-base text-gray-700 text-justify">
          <h2 className="text-2xl font-semibold mb-2">Postadresse</h2>
          <p>Ackerplus</p>
          <p>Bankstrasse 4</p>
          <p>8570 Weinfelden</p>

          <h2 className="text-2xl font-semibold mt-6 mb-2">Kontakt</h2>
          <p>
            <a href="tel:+41792566105" className="text-[#37813b] hover:underline">
              +41 79 256 61 05
            </a>
          </p>
          <p>
            <a href="mailto:hello@ackerplus.ch" className="text-[#37813b] hover:underline">
              hello@ackerplus.ch
            </a>
          </p>
        </div>
      </div>
    </div>
  </BaseLayout>
);

export default Impressum;
